import { BundleContext, PatientContext } from "../types/patientFeeds";

export const isBundleFeedContext = (
  context: PatientContext,
): context is BundleContext => (context as BundleContext).bundle !== undefined;
